import Vue from 'vue'
import VueX from 'vuex'

Vue.use(VueX)

const store = new VueX.Store({
	state: {
		loadingCount: 0,
		msgParam: null,
		user: null,
		appList: [],
		campaignDict: {}
	},
	mutations: {
		// loading 状态
		loading (state, val) {
			state.loadingCount = val ? state.loadingCount + 1 : state.loadingCount - 1
		},
		// 提示消息状态
		msgParam (state, val) {
			state.msgParam = val
		},
		// 已登录用户
		user (state, val) {
			state.user = val
		},
		// 应用列表
		appList (state, val) {
			state.appList = val
		},
		// 计划字典
		campaignDict (state, val) {
			state.campaignDict = val
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js